export default __webpack_public_path__ + "107e11d856ba4ca548f62f4245bf04b2.png";